/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popHowWorks.vue?vue&type=template&id=3531b4c7"
import script from "./popHowWorks.vue?vue&type=script&lang=js"
export * from "./popHowWorks.vue?vue&type=script&lang=js"
import style0 from "./popHowWorks.vue?vue&type=style&index=0&id=3531b4c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports